// extracted by mini-css-extract-plugin
var _1 = "SetPassword__container--gN8Z_";
export { _1 as "container" }
